import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";

import DialogContainer from '../containers/DialogContainer';
import shotServices from '../services/shotService';

export default class AddShotDialog extends Component{
  constructor(props){
    super(props);
    this.state = {
      shot:{
        scene: "",
        location: "",
        description: "",
        framing: "",
        angle: "",
        camera: "",
      },
      fetching: false
    }
  }

  handleClose = (type) => this.props.handleClose(type);
    
  saveShot = async () => {

    if(this.props.edit){
      console.log("editing")
      this.setState({ fetching: true })
      await shotServices.updateOneShot(this.state.shot.id,this.state.shot)
      this.setState({ fetching: false });
      this.handleClose(this.props.type);
      // this.props.getShots(this.props.type);
    }else{
      this.setState({ fetching: true })
      var shot = Object.assign({}, this.state.shot, {type:this.props.type})
      await shotServices.saveShot(shot);
      this.setState({ fetching: false });
      this.handleClose(this.props.type);
      // this.props.getShots(this.props.type);
    }

  } 

  handleChange = name => e =>  {
    let state = this.state
    state.shot[name]=e.target.value;
    this.setState(state);
  };

  onEnterDialog =() => {
    if(this.props.edit){
      this.setState({
        shot: this.props.shot
      })
    }else{
      this.setState({
        shot:{
          scene: "",
          location: "",
          description: "",
          framing: "",
          angle: "",
          camera: "",
        }
      })
    }
  }

  render(){
    let {props} = this
    return(
      <DialogContainer
        open={props.open}
        title={(props.edit ? "Edit" : "Add") + (props.type === "photo" ? "Photo" : "Video") + "Shot"}
        onClose={this.handleClose}
        onEnter={this.onEnterDialog}
        contentText={
          props.edit ?
          `To edit shot please enter the new and necessary informatiton. Click "Save Shot" to edit shot.`
          :
          `To add shot please enter the necessary informatiton. Click "Save Shot" to add shot.`
        }
        actions={
          <DialogActions>
            <Button variant="contained" onClick={()=>this.handleClose(null)} color="secondary">
              Cancel
            </Button>
            <Button variant="contained" onClick={this.saveShot} color="primary">
              Save Shot
              {
                this.state.fetching ? <CircularProgress size={12} color="inherit" style={{marginLeft: 5}} /> : null
              }
            </Button>
          </DialogActions>
        }
      >
        <TextField
          value={this.state.shot.scene}
          onChange={this.handleChange('scene')}
          label="Scene *"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
          />
        <TextField
          value={this.state.shot.location}
          onChange={this.handleChange('location')}
          label="Location *"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
          />
        <TextField
          value={this.state.shot.description}
          onChange={this.handleChange('description')}
          label="Description *"
          multiline
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
          />
        <TextField
          value={this.state.shot.framing}
          onChange={this.handleChange('framing')}
          label="Framing *"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
          />
        <TextField
          value={this.state.shot.angle}
          onChange={this.handleChange('angle')}
          label="Angle *"
          margin="normal"
          style={{ width: "100%", fontSize: "80px" }}
          variant="outlined"
        />
        <FormControl
          variant="outlined"
          style={{ width: "100%" }}
          margin="normal"
        >
          <InputLabel
            ref={ref => {
              this.labelRef = ReactDOM.findDOMNode(ref);
            }}
            htmlFor="outlined-age-native-simple"
          >
            Camera Movement *
          </InputLabel>
          <Select
            value={this.state.shot.camera}
            native
            input={
              <OutlinedInput
                label="Camera Movement *"
                name="Camera Movement *"
                labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                value={this.state.shot.camera}
                onChange={this.handleChange('camera')}
                style={{ width: "100%" }}
              />
            }
          >
            <option value="" />
            <option value="Static">Static</option>
            <option value="Static/Pan">Static/Pan</option>
            <option value="Static/Pan/Glide">Static/Pan/Glide</option>
            <option value="Any">Any</option>
            <option value="Following/Paning">Following/Paning</option>
            <option value="Following">Following</option>
            <option value="Following/Static">Following/Static</option>
            <option value="Focus Pull">Focus Pull</option>
            <option value="Pan/Glide">Pan/Glide</option>
          </Select>
        </FormControl>
      </DialogContainer>
    )
  }


}